module.exports = __webpack_public_path__ + "img/schiller-physiogard-touch-7.343aba82.png";